import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { automationQueryKeys } from "./automationQueryKeys";

export function useAutomationList({ api }: { api: ApiType }) {
  return useQuery({
    queryKey: automationQueryKeys.list(),
    queryFn: async () => {
      return (await api.automationApi.find()).data;
    },
  });
}
